import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d546ef96")

_pushScopeId("data-v-d546ef96")
const _hoisted_1 = { class: "tab df-middle" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TransitionPic = _resolveComponent("TransitionPic")
  const _component_t = _resolveComponent("t")
  const _component_RouterLink = _resolveComponent("RouterLink")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
      return (_openBlock(), _createBlock(_component_RouterLink, {
        custom: "",
        key: tab.path[0],
        to: tab.path[0]
      }, {
        default: _withId(({navigate}) => [
          _createVNode("div", {
            onClick: navigate,
            class: "flex-1 f-md f-bold df-cross-center"
          }, [
            _createVNode(_component_TransitionPic, {
              path: `tabs/${tab.icon}`,
              active: _ctx.isMatch(tab.path)
            }, null, 8, ["path", "active"]),
            _createVNode(_component_t, {
              class: _ctx.isMatch(tab.path) ? ['c-primary'] : [],
              path: tab.label
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(tab.labelDefault), 1)
              ]),
              _: 2
            }, 1032, ["class", "path"])
          ], 8, ["onClick"])
        ]),
        _: 2
      }, 1032, ["to"]))
    }), 128))
  ]))
})